export const PLAN_DONE_KEYS = {
  plan: 'plan',
  done: 'done',
  devDebt: 'devDebt',
  qaDebt: 'qaDebt',
  verificationFailed: 'verificationFailed',
  devDebtTrend: 'devDebtTrend',
  qaDebtTrend: 'qaDebtTrend',
} as const;

export type PlanDoneDataKey = (typeof PLAN_DONE_KEYS)[keyof typeof PLAN_DONE_KEYS];

export interface PlanDoneSeriesCopy {
  /** Short label shown in legend (metro-style signage). */
  legend: string;
  /** One compact line shown in chart tooltip header for this row. */
  tooltipLine: string;
  bullets: string[];
}

export const PLAN_DONE_SERIES_COPY: Record<PlanDoneDataKey, PlanDoneSeriesCopy> = {
  plan: {
    legend: 'Plan',
    tooltipLine: 'Work items counted in this period column.',
    bullets: [],
  },
  done: {
    legend: 'Done',
    tooltipLine: 'Finished work — snapshot of current status.',
    bullets: [],
  },
  devDebt: {
    legend: 'In Dev',
    tooltipLine: 'Work currently in development statuses.',
    bullets: [],
  },
  qaDebt: {
    legend: 'In QA',
    tooltipLine: 'Work currently in QA-related statuses.',
    bullets: [],
  },
  verificationFailed: {
    legend: 'Failed checks',
    tooltipLine: 'QA failures — counted as transitions.',
    bullets: [],
  },
  devDebtTrend: {
    legend: 'Trend · Dev',
    tooltipLine: 'Straight-line trend over “In Dev” values.',
    bullets: [
      'Shows direction only (better / worse tail).',
      'Optional — turn on with “Trend lines”.',
    ],
  },
  qaDebtTrend: {
    legend: 'Trend · QA',
    tooltipLine: 'Straight-line trend over “In QA” values.',
    bullets: ['Shows direction only.', 'Optional — turn on with “Trend lines”.'],
  },
};
